import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { AlternativesMessage } from '../AlternativesMessage';
import { SubdomainRootTaken } from './SubdomainRootTaken';
export const GENERAL_ANONYMOUS_OVERRIDE_DATA_HOOK = 'general-anonymous-override';
export const GeneralAnonymousOverride = props => {
  const domainName = props.domainName;
  if (parseDomain(domainName ?? '').subdomain) {
    return /*#__PURE__*/React.createElement(SubdomainRootTaken, props);
  }
  return /*#__PURE__*/React.createElement(AlternativesMessage, {
    domainName: domainName,
    dataHook: GENERAL_ANONYMOUS_OVERRIDE_DATA_HOOK
  });
};
//# sourceMappingURL=GeneralAnonymousOverride.js.map